import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';

const styles = theme => ({
  toolbar: theme.mixins.toolbar,
  root: {
    marginTop: 'auto',
    maxWidth: '100%',
  },
  content: {
    padding: 5,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  link: {
    paddingRight: 10,
    textDecoration: 'none',
    color: '#727272',
    fontSize: 10,
  },
});

const Footer = props => {
  const { classes } = props;
  return (
    <div className={classes.root}>
      <Divider />
      <div className={classes.content}>
        <a className={classes.link} href="https://www.agentbuzz.com/">
          About
        </a>
        <a className={classes.link} href="https://www.agentbuzz.com/#pricing">
          Pricing
        </a>
        <a className={classes.link} href="mailto: support@agentbuzz.com">
          Support
        </a>
        <a className={classes.link} href="https://www.agentbuzz.com/terms/">
          Terms
        </a>
      </div>
    </div>
  );
};

export default withStyles(styles)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.js